import {gbpMockPayees, eurMockPayees} from "../mock_data/payees";
import purposeCodes from "../mock_data/purposeCodes";

async function getFromUrl(response) {
  try {
    if (response.savedPayeesUrl) return (await window.fetch(response.savedPayeesUrl).then(x => x.json()));
    return response.savedPayees;
  } catch (error) {
    console.log("error fetching payees");
    return [];
  }
}

export default function getSavedPayees(currency, setShowOverlay, setPayees, setScreen, setPurposeCodes, setError) {
  setShowOverlay(true);
  if (!window.OrendaGetResponse || window.isSiteBuilder) {
    setTimeout(() => {
      currency === "GBP"
        ? setPayees(gbpMockPayees)
        : setPayees(eurMockPayees);
      setScreen("PayeesList");
      setPurposeCodes(purposeCodes);
      setShowOverlay(false);
    }, 1000);
    return;
  }

  window.OrendaGetResponse(
    {
      event_name: "getSavedPayees",
      data: JSON.stringify({ account: currency }),
    },
    async (response) => {
      if (response.error) return setError(true);
      // setPayees(response.savedPayees);
      setPayees(await getFromUrl(response));
      
      setScreen("PayeesList");
      setPurposeCodes(response.purpose_codes);
      setShowOverlay(false);
      return;
    }
  );
  setShowOverlay(true);
  return;
}